import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const CONTRACTMASTERGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ContractMasterGroup.Name')
    .required()
    .minLength(1)
    .maxLength(30)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ContractMasterGroup.Code')
    .required()
    .minLength(2)
    .maxLength(10)
    .build(),
];

export const CONTRACTMASTERGROUP_CONFIG = {
  entityName: 'ContractMasterGroup',
  localizationKey: 'Controlling::Entity.ContractMasterGroup',
  fields: CONTRACTMASTERGROUP_FIELDS,
  permission: 'ControllingContract.ContractMasterGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
